import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { type JSX } from 'react';
import styles from './style.module.css'
import Link from "next/link";

const StyledLink: React.FC<{href: string, children?: JSX.Element | string, icon?: IconDefinition }> = ({href, children, icon}) => {
  return (
    <Link className={styles.link} href={href} rel='me'>
      {icon ? (
        <FontAwesomeIcon className={styles.icon} icon={icon} height={24} />
      ) : null}
      {children}
    </Link>
  )
}

const LinkStack: React.FC<React.PropsWithChildren> = ({children}) => {
  return (
    <div className={styles.linkStack}>
      {children}
    </div>
  )
}

export {
  StyledLink,
  LinkStack
}